module.exports = __webpack_public_path__ + "img/monitor.ceb7eec8.png";